// extracted by mini-css-extract-plugin
export default {"iconTextContainer":"IconText_iconTextContainer__KZsu-","icon":"IconText_icon__emLLT"};